// eslint-disable-next-line import/no-anonymous-default-export
export default {
  OnlineScreen: 'HitPaw在线录屏器',
  RecordScreenWithAudio: '用音频录制整个屏幕、应用程序窗口或浏览器标签页',
  ScreenOnly: '仅（录制）屏幕',
  ScreenAndCam: '屏幕和网络摄像头',
  Microphone: '麦克风',
  SystemAudio: '系统声音',
  StartRecording: '开始录制',
  NoAudioAndTryAgain: '没有可用的音频源。请按照以下说明重试。',
  TheInstruction: '说明',
  AccessMicrophone: 'www.hitpaw.com 需要访问您的麦克风来录制音频，请点击允许！',
  BestScreenRecorderSoftware: '最佳屏幕录像机和免费视频流媒体软件',
  CaptureAnythingOnScreen:
    '捕捉和记录您的网站、讲座、视频通话以及屏幕上的任何内容',
  RecordToShare: '记录您的游戏亮点与朋友分享',
  StreamOnFackbook: '像专业人士一样在 Facebook、YouTube、Twitch 等上流式传输',
  BringMagic: '为直播和视频聊天带来神奇的虚拟网络摄像头',
  StepOne: '第一步：选择您要录制的屏幕。',
  StepTwo: '第二步：选择您要录制的屏幕。',
  StepThree: '第三步：点击“共享系统音频”。。',
  StepFour: '第二步：点击“分享”开始录制。',
  GrantPermission: '请授予屏幕录制权限，然后重试。',
  RecordingProgress: '正在录制...',
  MoreOptions: '更多录制选项：',
  Pause: '暂停',
  Continue: '继续',
  Stop: '停止',
  Webcam: '摄像头',
  GreenScreenAndChangeBackground: '绿屏和更改背景',
  StreamToYouTube: '流式传输到 Facebook、Twitch、YouTube 等。',
  ScheduleRecording: '定时录制',
  NewRecording: '新录音',
  ExportToMp4: '导出为 MP4',
  AddWatermark: '加水印',
  ChangeSpeed: '改变速度',
  CutAndTrim: '剪切和修剪',
  '120XDownload': '120X 更快的视频转换器和高清视频下载器',
  CovertAudioFormats: '将视频和音频文件转换为 1000 多种格式',
  DownloadVideoFromWebsites: '从 10000 多个视频共享网站下载并保存视频',
  BatchConvertImageAndGif: '批量转换图像并从视频创建 GIF',
  RichEdingingFeatures: '内置丰富的视频编辑功能：合并、剪切、裁剪、水印等。',
  BestVideoEditor: '为多用途设计的最佳视频编辑器',
  MakeSimpleEdits: '一个屡获殊荣的视频编辑器，让复杂的编辑变得简单。',
  BeyondImaginationMaterials: '各种超乎想象的内置和在线资料。',
  AqualityVideoMaker:
    '一个以质量为导向的视频制作者，可以完全免费地导出和分享 1080P/4K 视频。',
  WorkOnAnywhere: '可以在任何 PC 上安全运行，而不会影响其性能。',
  RecordCompleted: '录制完成',
  AlreadyHaveAccount: '已经有账号了?',
  LoginNow: '现在登录',
  exceedTenMin: 'Time is up for the 10-minute recording.',
  UpgradeToRecord: 'Upgrade to continue recording.',
  ScreenProFeature: 'HitPaw Online Screen Recorder Pro 功能',
  FreeScreenAccount: '免费帐户只有 <1><0>10</0></1> 分钟的录制时间',
  BuyNow: '立即购买',
  DownloadMp4: '下载（视频）为 MP4',
  FreeDownload: 'Free Download',
  Download: 'Download',
  DownloadTenMin: 'Download 10 Min',
  FullVideo: 'Full Video',
  FormatMp4: 'Download As MP4',
  Downloading: 'Downloading...',
  DownloadFailed: 'Failed to download, please try again.',
  DownloadSuccess: 'Download Successfully!',
  Exceed100MDownloadConvert:
    'Video size cannot exceed 100MB for downloading video in MP4 format. Download HitPaw Video Converter for more features.',
  Exceed30Min:
    'Video duration cannot exceed 30 minutes for downloading video in MP4 format. Download HitPaw Video Converter for more features.',
  Week: 'Week',
  BilledMonthly: 'Billed Monthly',
  ConvertText1:
    'Download Desktop Version to Batch Process Large Files With NO Size Limit',
  ConvertText2:
    'Batch convert video and audio files to 1000+ formats with 120X faster speed',
  ConvertText3:
    'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.',
  ConvertText4:
    'Convert Apple Music to MP3 with DRM removed (Windows version only)',
  TenMinUp: 'Time is up for the 10-minute recording.',
  UpgradeMore: 'Upgrade to continue recording.',
  NoRecordLimit: 'No time limit for screen recording',
  NoRecordNumLimit: 'No limit on the number of recording',
  MonthOff: '60% OFF',
  YearOff: '80% OFF',
  UpgradeNow: 'Upgrade Now',
  CheckConnect: 'Check your connection and try again.',
};
